import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=62d6900c&scoped=true"
import script from "./_id.vue?vue&type=script&lang=js"
export * from "./_id.vue?vue&type=script&lang=js"
import style0 from "./_id.vue?vue&type=style&index=0&id=62d6900c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d6900c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonTemplate: require('/qishanmall-website-view/components/common-template.vue').default})
